import { useCallback } from 'react';

import { SetValueConfig, useFormContext } from 'react-hook-form';
import { SingleValue } from 'react-select';

import { parseISO } from 'date-fns';

import { isDefined, isNotDefined } from '@hsp/utilities';

import { useFetchAudiences } from 'pages/audience/shared/save/hooks';
import { AudienceOrderType, IAudience } from 'types/api/audience';
import { SaveForm } from 'types/pages/audience-builder/shared/save';

export const useNameDropdownConfiguration = () => {
  const { data, isFetching, isLoading } = useFetchAudiences();
  const { control, resetField, setValue } = useFormContext<SaveForm>();

  const handleOnChange = useCallback(
    (option: SingleValue<IAudience>, onChange: (...event: unknown[]) => void) => {
      const options: SetValueConfig = { shouldDirty: true, shouldTouch: true, shouldValidate: true };

      if (isNotDefined(option)) {
        onChange(null);

        resetField('client');
        resetField('giftDateEnd');
        resetField('giftDateStart');
        resetField('name');
        resetField('orderNumber');

        setValue('orderTypeId', AudienceOrderType.NotSet);

        return;
      }

      const { clientId, clientName, giftDateEnd, giftDateStart, id, name, orderNumber, orderType } = {
        ...option,
      } as IAudience;

      onChange(id);
      setValue('name', name, options);
      setValue('orderNumber', orderNumber);

      if (isDefined(clientId) && isDefined(clientName)) {
        setValue('client', { id: clientId, name: clientName });
      }

      setValue('giftDateEnd', isDefined(giftDateEnd) ? parseISO(giftDateEnd.toString()) : null);
      setValue('giftDateStart', isDefined(giftDateStart) ? parseISO(giftDateStart.toString()) : null);

      if (isDefined(orderType)) {
        const { id: orderTypeId } = orderType;

        setValue('orderTypeId', orderTypeId, options);
      } else {
        setValue('orderTypeId', AudienceOrderType.NotSet);
      }
    },
    [resetField, setValue]
  );

  return { control, data, handleOnChange, isFetching, isLoading };
};
